import { Map, List, fromJS } from 'immutable'
import { handleActions } from 'redux-actions'
import ActionHelper from 'helpers/action'

// constants
export const FETCH_SITE_LIST = 'entry/FETCH_SITE_LIST'
export const SET_SITE_LIST = 'entry/SET_SITE_LIST'
export const FETCH_LOCUS_LIST = 'entry/FETCH_LOCUS_LIST'
export const SET_LOCUS_LIST = 'entry/SET_LOCUS_LIST'
export const SET_ACTIVE_SITE = 'entry/SET_ACTIVE_SITE'
export const SET_ACTIVE_LOCUS = 'entry/SET_ACTIVE_LOCUS'
export const SET_ACTIVE_PERIOD = 'entry/SET_ACTIVE_PERIOD'
export const SET_ACTIVE_TAB = 'entry/SET_ACTIVE_TAB'
export const RESET_ENTRY_STORE = 'entry/RESET_STORE'
export const SET_MOBILE_FILTERS = 'entry/SET_MOBILE_FILTERS'
export const UNSET_MOBILE_FILTERS = 'entry/UNSET_MOBILE_FILTERS'

// actions
export const fetchSiteList = ActionHelper.createActionObj(FETCH_SITE_LIST)
export const fetchLocusList = ActionHelper.createActionObj(FETCH_LOCUS_LIST)
export const setLocusList = ActionHelper.createActionObj(SET_LOCUS_LIST)
export const setActiveSite = ActionHelper.createActionObj(SET_ACTIVE_SITE)
export const setActiveLocus = ActionHelper.createActionObj(SET_ACTIVE_LOCUS)
export const setActivePeriod = ActionHelper.createActionObj(SET_ACTIVE_PERIOD)
export const setActiveTab = ActionHelper.createActionObj(SET_ACTIVE_TAB)
export const resetEntryStore = ActionHelper.createActionObj(RESET_ENTRY_STORE)
export const setMobileFilters = ActionHelper.createActionObj(SET_MOBILE_FILTERS)
export const unsetMobileFilters = ActionHelper.createActionObj(
  UNSET_MOBILE_FILTERS,
)

const initialState = fromJS({
  siteList: [],
  locusList: [],
  activeSite: null,
  activeLocus: null,
  activePeriod: { id: 'today', name: 'Today' }, // today | past | future
  activeTab: 'production', // production | health | feed | environment
  mobileFilters: true,
})

const entry = handleActions(
  {
    [SET_MOBILE_FILTERS]: state => state.set('mobileFilters', true),
    [UNSET_MOBILE_FILTERS]: state => state.set('mobileFilters', false),
    [SET_SITE_LIST]: (state, action) =>
      state.set('siteList', List(action.siteList)),
    [SET_LOCUS_LIST]: (state, action) =>
      state.set('locusList', List(action.locusList)),
    [SET_ACTIVE_SITE]: (state, action) =>
      state.set('activeSite', action.payload ? Map(action.payload) : null),
    [SET_ACTIVE_LOCUS]: (state, action) =>
      state.set('activeLocus', action.payload ? Map(action.payload) : null),
    [SET_ACTIVE_PERIOD]: (state, action) =>
      state.set('activePeriod', action.payload ? Map(action.payload) : null),
    [SET_ACTIVE_TAB]: (state, action) => state.set('activeTab', action.payload),
    [RESET_ENTRY_STORE]: state =>
      state
        .set('siteList', List([]))
        .set('locusList', List([]))
        .set('mobileFilters', true),
  },
  initialState,
)

export default entry
